import React from 'react';
import PropTypes from 'prop-types';

import { isBlank } from 'helpers/string_helpers';
import Button from 'shared/button';
import { Form } from 'react-bootstrap-5';

export class SavedSearchForm extends React.Component {
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  state = {
    name: ''
  }

  handleInput = e => this.setState({ name: e.target.value });

  render() {
    const { name } = this.state;
    const { onSave, onCancel } = this.props;
    const disabledSave = isBlank(name);
    return (
      <div className="p-1">
        <Form.Group className="mb-3">
          <Form.Label>Save this Search As:</Form.Label>
          <Form.Control
            placeholder="Enter a name"
            type="text"
            value={name}
            onChange={this.handleInput}
          />
        </Form.Group>

        <div className="d-flex gap-2">
          <Button.Cancel className="ms-auto" size="sm" onClick={onCancel}>Cancel</Button.Cancel>
          <Button.Primary
            disabled={disabledSave}
            size="sm"
            onClick={!disabledSave && (() => onSave(name))}
          >
            Save
          </Button.Primary>
        </div>
      </div>
    );
  }
}
